<template lang="html">
  <div class="footer">
    <div class="footer-head">
      <b><span style="font-size:12px">Plantravail.fr powered by IPA SARL - 54, rue Perthuis 92140 Clamart - Tél. : 01 46 31 63 80</span> - Design & Développement : <a href="mailto:bonjour@charlemagneagency.com">agence Charlemagne</a><br>
        <span style="font-size: 12px">Visitez également : <a href="http://www.ipa-paris.fr/" target="_blank">ipa-paris.fr</a> et <a href="http://adaptive-paris.com/" target="_blank">adaptive-paris.com</a></span>
      </b>
      <img src="/static/logo.svg" style="width: 100%;">
    </div>
    Corian® Glacier White Corian® Antarctica Corian® Arctic Ice Corian® Venaro White Corian® White Jasmine Corian® Glacier Ice Corian® Cameo White Corian® Seafoam Corian® Witch Hazel Corian® Bisque Corian® Rice Paper Corian® Linen Corian® Vanilla Corian® Abalone Corian® Whipped Cream Corian® Savannah Corian® Pearl Gray Corian® Bone Corian® Whisper Corian® Clam Shell Corian® Sandalwood Corian® Tumbleweed Corian® Cottage Lane Corian® Aurora Corian® Canvas Corian® Ecru Corian® Fossil Corian® Sahara Corian® Saffron Corian® Hickory Smoke Corian® Aztec Gold Corian® Mojave Corian® Burled Beach Corian® Granola Corian® Raffia Corian® Sand Storm Corian® Sand Corian® Absolute Beige Corian® Oat Corian® Sandstone Corian® Hazelnut Corian
® Matterhorn Corian® Doeskin Corian® Desert Corian® Fawn Corian® Riverbed Corian® Sonora Corian® Suede Corian® Maui Corian® Basil Corian® Thyme Corian® Royal Red Corian® Allspice Corian® Deep Bedrock  Corian® Cocoa Brown Corian® Canyon Corian® Bronzite Corian® Deep Espresso Corian® Sorrel Corian® Earth Corian® Willow Corian® Sagebrush Corian® Concrete Corian® Jasmine Corian® Noble Ecru Corian® Mint Ice Corian® Cilantro Corian® Dove Corian® Aqualite Corian® Pine Corian® Serene Sage Corian® Rosemary Corian® Moss Corian® Silt Corian® Silver Birch Corian® Arrowroot Corian® Rain Cloud Corian® Juniper Corian® Blue Pebble Corian® Stardust Corian® Mineral Corian® Moonlit Sea Corian® Blue Spice Corian® Elderberry Corian® Cobalt Corian® Silverite Corian® Platinum Corian® Natural Gray Corian® Silver Gray Corian® Elegant Gray Corian® Graylite Corian® Deep Mink Corian® Deep Sable Corian® Milky Way Corian® Lava Rock Corian® Flint Corian® Anthracite Corian® Deep Caviar Corian® Deep Storm Corian® Deep Space Corian® Deep Black Quartz Corian® Deep Night Sky Corian® Deep Nocturne Corian® Deep Anthracite Corian® Deep Cloud Corian® Deep Inkwell Corian® Deep Lapis Corian® Deep Smoky Pearl Corian® Deep Terrain Corian® Deep Titanium Corian® Modern White Corian® Nightfall
  <a class="question" href="mailto:contact@plantravail.fr" id="btn_question">
    Une question ?
  </a>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.footer {
  background: #f3f3f3;
  font-size: 10px;
  padding: 50px 30px 100px 30px;
  box-sizing: border-box;
  color: #8f8f8f;
  position: relative;
  text-align: left;
}
a {
  color: #4e4e4e
}
.footer-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  color: #4e4e4e;
}
.footer-head img {
  width: 60px;
  max-width: 60px;
  height: 100%;
  margin-top: -15px;
}
.question {
  padding: 10px 20px;
  background: #ff0000;
  color: #FFF;
  position: absolute;
  font-size: 18px;
  font-weight: bold;
  top: -43px;
  right: 50px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-decoration: none;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// Foot.vue?589945f8